import { createContext, useEffect, useState } from "react";

export const AutoReportContentContext = createContext();

const initialReportContentState = {
  admissionPhdFullTime: "",
  admissionPhdPartTime: "",
  awardOfPhdFullTime : "",
  awardOfPhdPartTime: "",
  awards: "",
  functions: "",
  meetings:""
};

export const ADMISSION_PHD_FULLTIME = "admissionPhdFullTime";
export const ADMISSION_PHD_PARTTIME = "admissionPhdPartTime";
export const AWARD_OF_PHD_FULL_TIME = "awardOfPhdFullTime";
export const AWARD_OF_PHD_PART_TIME = "awardOfPhdPartTime";
export const AWARDS = "awards";
export const FUNCTIONS = "functions";
export const MEETINGS = "meetings"

export const AutoReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <AutoReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </AutoReportContentContext.Provider>
  );
};
